module.exports = __webpack_public_path__ + "static/media/128-vision.b58dfa46.svg";